import { useMemo } from 'react';
import { useUserProfile } from '../contexts/UserProfileContext';
import { createTestDataFilters } from '../utils/testData';

/** Mevcut kullanıcıya göre test kayıtlarını ayıklayan süzgeçler (bkz. utils/testData). */
const useTestDataFilters = () => {
  const { employeeData } = useUserProfile();
  const email = employeeData?.eMail;
  return useMemo(() => createTestDataFilters(email), [email]);
};

export default useTestDataFilters;
